export default class InsurancePayment {

    public date: Date | null = null;

    public amount: string | null = null;

}
